export default "<button title=\"Approve\" class=\"btn btn-success\" (click)=\"approve()\">Approve</button>";